export default __webpack_public_path__ + "static/media/payer.d035208b.svg";